import React from 'react';
import Header from './Header';
import Footer from './Footer';

export default function Layout({ children, isHomePage = false, scrollToSection, activeSection }) {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Header 
        isHomePage={isHomePage}
        scrollToSection={scrollToSection}
        activeSection={activeSection}
      />
      <main>{children}</main>
      <Footer />
    </div>
  );
}